"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/watchListViewModel',["require", "exports", "knockout", "services/watchListService", "routing/mainRouter", "viewModels/policyViewModel", "moment", "models/userIdentityModel"], function (require, exports, ko, watchListService, mainRouter, policyViewModel, moment, userIdentityModel) {
    "use strict";

    var WatchListViewModel = function () {
        function WatchListViewModel() {
            var _this = this;

            _classCallCheck(this, WatchListViewModel);

            //this.getWatchedPolicies();
            this.watchedPolicies = ko.observableArray();
            this.watchedPoliciesCount = ko.observable(0);
            this.isWatchingPolicy = ko.observable(false);
            this.watchedPolicyReason = ko.observable('');
            this.watchedPolicyAdded = ko.observable('');
            this.updateInterval = null;
            this.watchInterval = null;
            this.lastBaseComponentRoute = '';
            this.policyHubConnection = null;
            this.setupWatchIntervals(mainRouter.router.component());
            this.componentSubscription = mainRouter.router.component.subscribe(function (component) {
                _this.setupWatchIntervals(component);
            });
            /*		policyHub.connect().done(function () {
                        policyHub.start().done(function () {
            
                            policyHub.connection.on("IsWatching", (environment: string, policyId: number, isWatching: boolean) => {
            
                                if (environment.toLowerCase() === policyViewModel.environment.toLowerCase() && policyId === policyViewModel.policy().id) {
                                    this.isWatchingPolicy(isWatching);
                                }
                            });
            
                        }.bind(this));
            
                    }.bind(this));*/
            /*		hubService.getHubAccess('TestHub').done(function (response) {
            
                        var testHubConnection = new signalR.HubConnectionBuilder()
                            .withUrl(response.url, { accessTokenFactory: () => response.accessToken })
                            .build();
            
                        testHubConnection.start().then(function () {
            
                        }.bind(this));
                    });*/
            /*		hubService.getHubAccess('PolicyHub').done(function (response) {
            
                        */ /*this.policyHubConnection = new signalR.HubConnectionBuilder()
                           .withUrl('/policyhub')
                           .build();*/ /*
                                       this.policyHubConnection = new signalR.HubConnectionBuilder()
                                       .withUrl(response.url, { accessTokenFactory: () => response.accessToken })
                                       .build();
                                       this.policyHubConnection.start().then(function () {
                                       this.policyHubConnection.on("IsWatching", (environment: string, policyId: number, isWatching: boolean) => {
                                       if (environment.toLowerCase() === policyViewModel.environment.toLowerCase() && policyId === policyViewModel.policy().id) {
                                       this.isWatchingPolicy(isWatching);
                                       }
                                       });
                                       }.bind(this));
                                       }.bind(this));*/
        }

        _createClass(WatchListViewModel, [{
            key: "getWatchedPolicies",
            value: function getWatchedPolicies() {
                if (userIdentityModel.sessionId()) {
                    watchListService.getWatchedPolicies().then(function (watchedPolicies) {
                        if (watchedPolicies) {
                            this.watchedPolicies(watchedPolicies);
                            this.watchedPoliciesCount(watchedPolicies.length);
                        }
                    }.bind(this));
                }
            }
        }, {
            key: "checkIfWatching",
            value: function checkIfWatching() {
                if (policyViewModel.policy() != null) {
                    watchListService.isWatching(policyViewModel.policy().id, policyViewModel.policy().brokerPolicyId).then(function (watchedPolicy) {
                        if (watchedPolicy) {
                            this.isWatchingPolicy(true);
                            this.watchedPolicyReason(watchedPolicy.reason);
                            this.watchedPolicyAdded(moment(watchedPolicy.added).format('YYYY/MM/DD hh:mm:ss'));
                        } else {
                            this.isWatchingPolicy(false);
                            this.watchedPolicyReason('');
                            this.watchedPolicyAdded('');
                        }
                        //policyHub.setIsWatching(this.isWatchingPolicy());
                    }.bind(this));
                }
            }
        }, {
            key: "setupWatchIntervals",
            value: function setupWatchIntervals(component) {
                if (component) {
                    var baseComponentRoute = component.split(':')[0];
                    if (baseComponentRoute !== this.lastBaseComponentRoute) {
                        this.setupWatchedPoliciesInterval(baseComponentRoute);
                        this.checkIfWatching();
                        this.setupIsWatchingPolicyInterval(baseComponentRoute);
                    }
                    this.lastBaseComponentRoute = baseComponentRoute;
                }
            }
        }, {
            key: "setupWatchedPoliciesInterval",
            value: function setupWatchedPoliciesInterval(baseComponentRoute) {
                var _this2 = this;

                if (baseComponentRoute === 'watch' && !this.updateInterval) {
                    this.getWatchedPolicies();
                    this.updateInterval = setInterval(function () {
                        _this2.getWatchedPolicies();
                    }, 5000);
                } else {
                    clearInterval(this.updateInterval);
                    this.updateInterval = null;
                }
            }
        }, {
            key: "setupIsWatchingPolicyInterval",
            value: function setupIsWatchingPolicyInterval(baseComponentRoute) {
                var _this3 = this;

                if (baseComponentRoute === 'policies' && !this.watchInterval) {
                    this.checkIfWatching();
                    this.watchInterval = setInterval(function () {
                        _this3.checkIfWatching();
                    }, 5000);
                } else {
                    clearInterval(this.watchInterval);
                    this.watchInterval = null;
                }
            }
        }, {
            key: "dispose",
            value: function dispose() {
                this.componentSubscription.dispose();
                if (this.updateInterval != null) {
                    clearInterval(this.updateInterval);
                    this.updateInterval = null;
                }
                if (this.watchInterval != null) {
                    clearInterval(this.watchInterval);
                    this.watchInterval = null;
                }
            }
        }]);

        return WatchListViewModel;
    }();

    return new WatchListViewModel();
});
//# sourceMappingURL=watchListViewModel.js.map;
